import type { FC } from 'react';

export type SearchResultPageLoadingFallbackProps = {};

/**
 * Loading fallback displayed while search result is still not available
 * */
export const SearchResultPageLoadingFallback: FC<SearchResultPageLoadingFallbackProps> = () => null;
